import React from 'react';
import * as styles from '../base.scss';
import Image from 'Shared/ImageFallback';
const BadgeBlock = ({ productViewModel }) => {
    return (productViewModel.articleBadgeIconUrl && (React.createElement("div", { className: styles.badgeIcon },
        React.createElement(Image, { src: productViewModel.articleBadgeIconUrl, size: "original" }))));
};
export default BadgeBlock;
